import { ReactNode } from "react";
import cs from "classnames";
import styles from "./index.module.scss";

type PropsType = {
  children: ReactNode | ReactNode[];
  noPad?: boolean;
};

const OpenCard = ({ children, noPad = false }: PropsType) => {
  return (
    <div className={cs(styles.container, noPad && styles.noPad)}>
      {children}
    </div>
  );
};

export default OpenCard;
